import React, { useEffect, useState } from "react";

import { Box, Stack } from "@origin-digital/ods-core";
import { AndroidStoreLink } from "@origin-digital/style-guide";
import { navigation } from "@origin-digital/reporting-client";
import { ExperienceProvider } from "@origin-digital/features";
import { navTo } from "@origin-digital/event-dispatcher";

import { links } from "src/consts";
import { isAuthenticated } from "src/utils/auth";
import { Loading } from "src/components/Loading";
import { RegisterSection } from "src/components/RegisterSection";

import { StaticPageInterstitial } from "src/components/StaticPageInterstitial";
import { PreRender } from "src/components/PreRender";
import { HeroSection } from "src/components/HeroSection";

import { FeatureSection } from "./sections/FeatureSection";
import { BenefitSection } from "./sections/BenefitSection";
import { AppSection } from "./sections/AppSection";

import heroContent from "./sections/HeroSection/content.json";
import heroAssets from "./sections/HeroSection/assets.json";

import registerContent from "./sections/RegisterSection/content.json";

export const MyAccountSetup: React.FC = () => {
  const { href, pathname, search } = window.location;
  const [loading, setLoading] = useState(true);
  const MBOX = "interstitial-myaccountsetup";

  useEffect(() => {
    (async () => {
      const isAuth = await isAuthenticated();
      const params = {};
      new URLSearchParams(search).forEach((value, key) => {
        params[key] = value;
      });

      if (isAuth) {
        return navTo.dashboard({ ...params } as any);
      }

      navigation("screen", {
        currentUri: href,
        path: pathname,
      });

      setLoading(false);
    })();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box data-id="my-account-setup">
      <ExperienceProvider mboxes={[MBOX]}>
        <StaticPageInterstitial mbox={MBOX} />
        <PreRender>
          <AndroidStoreLink />
        </PreRender>
        <Stack space="xsmall">
          <Stack
            space={{
              sm: "none",
              xs: "xsmall",
            }}
          >
            <HeroSection content={heroContent} assets={heroAssets} fullWidth />
            <FeatureSection />
          </Stack>
          <BenefitSection />
          <AppSection />
        </Stack>

        <RegisterSection content={registerContent} link={links.register} />
      </ExperienceProvider>
    </Box>
  );
};
